export const DEMO_MODE_STORAGE_KEY = 'TT_DEMO_MODE_ENABLED'

function readGlobalDemoFlag(): boolean | null {
  const globalFlag = (globalThis as any).__TIMETHREAD_DEMO_MODE__
    ?? (globalThis as any).TIMETHREAD_DEMO_MODE
    ?? (globalThis as any).TT_DEMO_MODE

  if (globalFlag === true) return true
  if (globalFlag === false) return false
  return null
}

export function getGlobalDemoModeOverride(): boolean | null {
  return readGlobalDemoFlag()
}

export function isDemoModeEnabled(): boolean {
  const globalOverride = readGlobalDemoFlag()
  if (globalOverride !== null) {
    return globalOverride
  }

  try {
    return localStorage.getItem(DEMO_MODE_STORAGE_KEY) === 'true'
  } catch {
    return false
  }
}

export function setDemoModeEnabled(enabled: boolean): void {
  localStorage.setItem(DEMO_MODE_STORAGE_KEY, enabled ? 'true' : 'false')
}
